export const blacklist = [
    "Minereum BSC",
    "0Apply Rich Token",
    "Dex88.org",
    "ALPACAFIN.COM",
    "BestAir.io",
    "GoFlux.io",
    "LinkP.io",
    "AGMC.io",
    "TheVera.io",
    "Zepe.io",
    "AirStack.net",
    "Crypto Gold Box",
    "BSCmello.io",
    "Binance-Peg BTG Token",
    "SAFEMOON.is",
    "MiniDoge.io",
    "AABEK.net",
    "Quidax Token",
    "ShibaDrop.io",
    "ABFIN.org",
    "BNBw.io",
    "VeloChain.io",
    "BSCTOKEN.IO",
    null,
    "Cookie",
    "Rotomico",
    "Pikatic"

]